import { Input } from './styles';

export function InputComponent({
  id, type, value, onChange, placeholder, readOnly, style
}: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) {
  return (
    <Input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly ? readOnly : false}
      style={style}
    />
  );
}
